/* global angular, _, $ */
angular.module('ua5App')
    .directive('dropdownSelect', ['$rootScope', function($rootScope) {
        return {
            restrict: 'A',
            templateUrl: 'components/dropdown/dropdown.html',
            scope: {
                list: '=',
                model: '=',
                multiselect: '@'
            },
            link: function($scope, element, attrs) {

                $scope.menuOpen = false;
                $scope.selectedDisplay = '';
                $scope.modelHolder = [];

                function processModel() {
                    if ($scope.model && $scope.multiselect) {
                        if (typeof($scope.model) === 'string' && $scope.model.indexOf(',') > -1) {
                            $scope.modelHolder = $scope.model.split(',').filter(Boolean);
                        } else if (!$.isArray($scope.model)) {
                            $scope.modelHolder = [$scope.model];
                        }
                    }
                }
                processModel();

                function processSelectedDisplay() {
                    var selectedItem;
                    if ($scope.multiselect) {
                        if ($scope.modelHolder.length > 1) {
                            var tempName = _.findWhere($scope.list, {value: ''}).name;
                            $scope.selectedDisplay = tempName.replace(/all/ig, 'Multiple');
                        } else {
                            var val = $scope.modelHolder[0] ? $scope.modelHolder[0] : '';
                            selectedItem = _.findWhere($scope.list, {value: val});
                            if (selectedItem) {
                                $scope.selectedDisplay = selectedItem.name;
                            }
                        }

                    } else {
                        selectedItem = _.findWhere($scope.list, {value: $scope.model});
                        if (selectedItem) {
                            $scope.selectedDisplay = selectedItem.name;
                        }
                    }
                }

                processSelectedDisplay();

                function menuHandlerFunction(event) {
                    $scope.$apply(function() {
                        $scope.menuOpen = false;
                    });
                    $('body').unbind('click', menuHandlerFunction);
                }

                $scope.$watch('menuOpen', function(newVal, oldVal) {
                    if (newVal === true) {
                        $rootScope.$broadcast('dropdownSelectOpen', $scope.$id);
                        $('body').bind('click', menuHandlerFunction);
                    } else {
                        $('body').unbind('click', menuHandlerFunction);
                    }
                });

                $scope.$watch('model', function() {
                    // put it here incase the parent scope wants to change the model
                    processModel();
                    processSelectedDisplay();
                });

                $scope.$watch('list', function() {
                    processSelectedDisplay();
                });

                $scope.$on('dropdownSelectOpen', function(e, scopeId) {
                    if (scopeId !== $scope.$id) {
                        $scope.menuOpen = false;
                    }
                });

                element.bind('click', function(e) {
                    e.stopPropagation();
                });

                $scope.updateModel = function(value) {
                    if ($scope.multiselect) {
                        var index;
                        processModel();

                        if (value === '') {
                            $scope.modelHolder = [value];
                            // close menu if "all" is clicked
                            $scope.menuOpen = false;
                        } else if (_.indexOf($scope.modelHolder, value) > -1) {
                            index = _.indexOf($scope.modelHolder, value);
                            $scope.modelHolder.splice(index, 1);
                        } else {
                            $scope.modelHolder.push(value);
                        }

                        if (value !== '') {
                            index = _.indexOf($scope.modelHolder, '');
                            if (index > -1) {
                                $scope.modelHolder.splice(index, 1);
                            }
                        }

                        $scope.model = $scope.modelHolder.join();
                        processSelectedDisplay();
                    } else {

                        $scope.model = value;
                        processSelectedDisplay();
                        $scope.menuOpen = false;
                    }
                };

                $scope.valueInModel = function(value) {
                    if ($scope.multiselect) {
                        return _.contains($scope.modelHolder, value);
                    } else {
                        return $scope.model === value;
                    }
                };
            }
        };
    }])
;
